import * as React from 'react'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import {
  GqlFollowingsDocument,
  useUnfollowChannelMutation,
} from 'generated/graphql'
import Button from '@app.components/Button'
import Modal, { IFModalProps } from 'app.components/Modal/Modal'
import { mobileBreakPoint } from 'app.styled/media'

interface UnFollowModalProps extends IFModalProps {
  channelId: string
}

const UnFollowModal: React.FC<UnFollowModalProps> = ({
  channelId,
  onClose,
  ...props
}) => {
  const unfollowChannelMutation = useUnfollowChannelMutation()

  const handleClickConfirm = () => {
    const [mutate] = unfollowChannelMutation
    mutate({
      variables: {
        channelId: channelId,
      },
      refetchQueries: [
        {
          query: GqlFollowingsDocument,
          variables: {
            Pagination: {
              page: 1,
              pageSize: 10,
            },
          },
        },
      ],
    })
    onClose && onClose()
  }
  return (
    <Modal onClose={onClose} {...props}>
      <StyledWrapper className="common-modal">
        <div className="close-btn" onClick={onClose}>
          <Close />
        </div>
        <div className="modal-title">정말 취소하시겠어요?</div>
        <div className="modal-description">
          팔로우를 취소하면 이 채널에 새로운 소식이나
          <br />
          공고가 등록될 시 알림을 받아 볼 수 없게 됩니다.
        </div>
        <div className="btn-list">
          <Button color="grey" className="btn cancle" onClick={onClose}>
            취소
          </Button>
          <Button className="btn" onClick={handleClickConfirm}>
            확인
          </Button>
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default UnFollowModal

const StyledWrapper = styled.div`
  width: 100%;
  max-width: 450px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;

  .close-btn {
    align-self: flex-end;
    color: #999999;
    cursor: pointer;
  }
  .modal-title {
    font-size: 24px;
    font-weight: 600;
  }
  .modal-description {
    font-size: 16px;
    margin: 20px 0 30px;
    text-align: center;
  }
  .btn-list {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    .btn {
      font-size: 16px;
      padding: 13px 30px;
      &.cancle {
        background-color: #bbbbbb;
      }
    }
  }
  ${mobileBreakPoint} {
    max-width: 350px;
  }
`
